import React, { useState } from 'react';
import {auth, db, getFirebaseErrorMessage} from '../../utils/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import {useLang} from "../../context/LanguageContext";
import BackButton from "../../components/BackButton";
import Api from "../../utils/Api";

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [password2, setPassword2] = useState('');
  const [isPassword2Visible, setIsPassword2Visible] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const { t, language } = useLang();

  const handleRegister = async () => {
    if (!acceptedTerms) {
      alert(t('auth.error_terms_msg'));
      return;
    }

    if (!name.trim()) {
      alert(t('auth.error_name_msg'));
      return;
    }
    if(password.length === 0){
      alert(t('auth.error_password_msg'));
      return;
    }
    if(password2.length === 0){
      alert(t('auth.error_password2_msg'));
      return;
    }
    if(password !== password2){
      alert(t('auth.error_password3_msg'));
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const apiData = await Api.createCustomer(email, name);

      const userDb = process.env.REACT_APP_FIREBASE_USER_DB;
      const userDocRef = doc(db, userDb, user.uid);
      await setDoc(userDocRef, {
        email: email,
        name: name,
        customerID: apiData.customerID
      });

      alert(t('auth.registration_successfully'));
      navigate('/account');
    } catch (error) {
      console.error(error);
      console.error(error.message);
      console.error(error.code);
      alert(getFirebaseErrorMessage(error.code, language));
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 relative">
      <BackButton onClick={() => navigate('/login')} />

      <h1 className="mb-4 text-xl font-bold">Register</h1>
      <div className="w-64 mb-4">
        <input
            type="text"
            placeholder={t('auth.name')}
            className="w-full mb-2 px-3 py-2 border rounded"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
        />
        <input
            type="email"
            placeholder={t('auth.email')}
            className="w-full mb-2 px-3 py-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
        />


        <div className="relative">
          <input
              type={isPasswordVisible ? 'text' : 'password'}
              placeholder={t('auth.password')}
              className="w-full mb-2 px-3 py-2 border rounded"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
          />
          <button
              type="button"
              onClick={() => setIsPasswordVisible((prev) => !prev)}
              className="absolute top-1/2 right-3 transform -translate-y-1/2 translate-x-1/4"
          >
            {isPasswordVisible ? (
                <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L22 22" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path
                      d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335"
                      stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path
                      d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818"
                      stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="32px" viewBox="0 0 32 40">
                  <g>
                    <path d="M37.087,17.705c-0.334-0.338-8.284-8.276-18.327-8.276S0.766,17.367,0.433,17.705c-0.577,0.584-0.577,1.523,0,2.107
              c0.333,0.34,8.284,8.277,18.327,8.277s17.993-7.938,18.327-8.275C37.662,19.23,37.662,18.29,37.087,17.705z M18.76,25.089
              c-6.721,0-12.604-4.291-15.022-6.332c2.411-2.04,8.281-6.328,15.022-6.328c6.72,0,12.604,4.292,15.021,6.332
              C31.369,20.802,25.501,25.089,18.76,25.089z M18.76,13.009c3.176,0,5.75,2.574,5.75,5.75c0,3.175-2.574,5.75-5.75,5.75
              c-3.177,0-5.75-2.574-5.75-5.75C13.01,15.584,15.583,13.009,18.76,13.009z"/>
                  </g>
                </svg>
            )}
          </button>
        </div>



        <div className="relative">
          <input
              type={setIsPassword2Visible ? 'text' : 'password'}
              placeholder={t('auth.password2')}
              className="w-full mb-2 px-3 py-2 border rounded"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              required
          />
          <button
              type="button"
              onClick={() => setIsPassword2Visible((prev) => !prev)}
              className="absolute top-1/2 right-3 transform -translate-y-1/2 translate-x-1/4"
          >
            {isPassword2Visible ? (
                <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L22 22" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path
                      d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335"
                      stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path
                      d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818"
                      stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="32px" viewBox="0 0 32 40">
                  <g>
                    <path d="M37.087,17.705c-0.334-0.338-8.284-8.276-18.327-8.276S0.766,17.367,0.433,17.705c-0.577,0.584-0.577,1.523,0,2.107
              c0.333,0.34,8.284,8.277,18.327,8.277s17.993-7.938,18.327-8.275C37.662,19.23,37.662,18.29,37.087,17.705z M18.76,25.089
              c-6.721,0-12.604-4.291-15.022-6.332c2.411-2.04,8.281-6.328,15.022-6.328c6.72,0,12.604,4.292,15.021,6.332
              C31.369,20.802,25.501,25.089,18.76,25.089z M18.76,13.009c3.176,0,5.75,2.574,5.75,5.75c0,3.175-2.574,5.75-5.75,5.75
              c-3.177,0-5.75-2.574-5.75-5.75C13.01,15.584,15.583,13.009,18.76,13.009z"/>
                  </g>
                </svg>
            )}
          </button>
        </div>
      </div>

      <div className="w-64 flex items-start space-x-2 mb-4">
        <input
            id="terms"
            type="checkbox"
            className="mt-1"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
        />
        <label className="text-sm" htmlFor="terms">
          {t('auth.terms1')}&nbsp;
          <Link to="/terms" className="text-blue-600 underline">
            {t('auth.terms2')}
          </Link>
        </label>
      </div>

      <button
          onClick={handleRegister}
          className="px-4 py-2 bg-[#27ae60] text-white rounded"
      >
        Create Account
      </button>
    </div>
  );
};

export default RegisterPage;
